var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.75H4.875C6.11251 21.75 7.125 20.7375 7.125 19.5V12.825C7.125 11.58 6.11251 10.575 4.875 10.575H3C1.76249 10.575 0.75 11.58 0.75 12.825V19.5C0.75 20.7375 1.76249 21.75 3 21.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 6.41249H11.0625C9.82499 6.41249 8.8125 7.42498 8.8125 8.66249V19.5C8.8125 20.7375 9.82499 21.75 11.0625 21.75H12.9375C14.175 21.75 15.1875 20.7375 15.1875 19.5V8.66249C15.1875 7.42497 14.175 6.41249 12.9375 6.41249Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.25H19.125C17.8875 2.25 16.875 3.26249 16.875 4.5V19.5C16.875 20.7375 17.8875 21.75 19.125 21.75H21C22.2375 21.75 23.25 20.7375 23.25 19.5V4.5C23.25 3.26249 22.2375 2.25 21 2.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.9cbe7f5c0268166c8651236ec5215a4c.svg";
export { ForwardRef as ReactComponent };